// extracted by mini-css-extract-plugin
var _1 = "ALT_u29cfV9b9GrZqmiQ";
var _2 = "YzCIW8i4koHl7cD55h8q";
var _3 = "Q3801htlaXLFMEFJugOI";
var _4 = "#000000";
var _5 = "#76F366";
var _6 = "#EB8632";
var _7 = "#ECC834";
var _8 = "#21FC87";
var _9 = "#EA4A30";
var _a = "#C7EA45";
var _b = "#272B2B";
var _c = "#BDBDBD";
var _d = "#7D7D7D";
var _e = "#6A0DAD";
var _f = "#3A65FF";
var _10 = "#4A90E2";
var _11 = "#ffffff";
var _12 = "GBdS3oFjA_JXmAobc1Cp";
var _13 = "vaj8GMEs7JdTBEdRWjLi";
var _14 = "hMf9RIbXonqcMjja3BcH";
var _15 = "XJ_GNvHLaNz6ZLPHKq4f";
var _16 = "v2ERFUQugiDSuX3jtnH1";
var _17 = "Jdc0p1QameeiCs_ofBEs";
var _18 = "Qjbw_ocHQ0CtDCDXukSj";
var _19 = "wlqQCNVNd4hHRJkE0KfQ";
var _1a = "f0vCoQywbi8BgACXHMbO";
var _1b = "1200px";
var _1c = "992px";
var _1d = "1366px";
var _1e = "768px";
var _1f = "1475px";
var _20 = "576px";
var _21 = "1600px";
var _22 = "320px";
var _23 = "2500px";
var _24 = "_v8J3ETtmtSbh7AZiB_2";
export { _1 as "active-media-preview", _2 as "base-link", _3 as "bounce", _4 as "colorBlack", _5 as "colorGradeEX", _6 as "colorGradeFR", _7 as "colorGradeGD", _8 as "colorGradeOU", _9 as "colorGradePR", _a as "colorGradeVG", _b as "colorNeutral", _c as "colorNeutralLighest", _d as "colorNeutralLight", _e as "colorNonOwnerSweetLine", _f as "colorOwnerSweetLine", _10 as "colorRegularLinks", _11 as "colorWhite", _12 as "loader", _13 as "loaderBlack", _14 as "loaderColored", _15 as "loaderLarge", _16 as "loaderMedium", _17 as "loaderSmall", _18 as "loaderWhite", _19 as "loaderXSmall", _1a as "reset-button", _1b as "screenlg", _1c as "screenmd", _1d as "screenml", _1e as "screensm", _1f as "screenxlg", _20 as "screenxs", _21 as "screenxxlg", _22 as "screenxxs", _23 as "screenxxxlg", _24 as "single-page-responsive-font-size" }
export default { "active-media-preview": _1, "base-link": _2, "bounce": _3, "colorBlack": _4, "colorGradeEX": _5, "colorGradeFR": _6, "colorGradeGD": _7, "colorGradeOU": _8, "colorGradePR": _9, "colorGradeVG": _a, "colorNeutral": _b, "colorNeutralLighest": _c, "colorNeutralLight": _d, "colorNonOwnerSweetLine": _e, "colorOwnerSweetLine": _f, "colorRegularLinks": _10, "colorWhite": _11, "loader": _12, "loaderBlack": _13, "loaderColored": _14, "loaderLarge": _15, "loaderMedium": _16, "loaderSmall": _17, "loaderWhite": _18, "loaderXSmall": _19, "reset-button": _1a, "screenlg": _1b, "screenmd": _1c, "screenml": _1d, "screensm": _1e, "screenxlg": _1f, "screenxs": _20, "screenxxlg": _21, "screenxxs": _22, "screenxxxlg": _23, "single-page-responsive-font-size": _24 }
